<script>
import MoveToRequisitionModal from "./MoveToRequisitionModal.vue";

export default {
    components: {
        MoveToRequisitionModal,
    },

    props: {
        users: {
            type: Array,
            required: true,
        },
        requisitions: {
            type: Array,
            required: true,
        },
        jobs: {
            type: Array,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            select: [],
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.getSelected();
        });
        this.$el.addEventListener("click", this.getSelected());
    },
    beforeDestroy: function() {
        this.$el.removeEventListener("click", this.getSelected());
    },
    methods: {
        getSelected() {
            this.select = [...new Set(this.users)];
            const elements = document.querySelectorAll(".candidate-id");
            elements.forEach((element) => {
                if (element.checked) {
                    this.select.push(element.value);
                    console.log(element.checked, element.value);
                }
            });
            this.select = [...new Set(this.select)];
            return this.select;
        },

        toggleModal(ref) {
            this.getSelected();
            this.$nextTick(() => {
                this.$refs[ref].toggleModal();
            });
        },
    },
};
</script>

<template>
    <div>
        <button class="invite-button" name="invite-button" type="submit">
          INVITE CANDIDATE
        </button> &nbsp;
        <button class="invite-button move-to-requisition-btn" name="move-to-requisition-btn" type="button" @click="toggleModal('moveToRequisitionModal')">
          MOVE TO REQUISITION
        </button>
        <move-to-requisition-modal ref="moveToRequisitionModal" :users="select" :jobs="jobs" :requisitions="requisitions" :csrf-token="csrfToken" />
    </div>
</template>

<style lang="scss">
a.button,
button.button {
    width: unset;
    font-size: 14px;
    padding: 8px 12px;
    line-height: 14px;
    margin-top: 35px;
    &.small {
        padding: 4px 8px;
        width: unset;
        margin-top: 35px;
        font-size: 12px;
        line-height: 12px;
        &.expanded {
            margin-bottom: 1rem;
        }
    }
}

.button.small-rounded {
    border-radius: 999px;
    width: 24px;
    height: 24px;
    position: relative;
    margin-top: -18px;
    >* {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        display: block;
        padding: 0;
    }
}
</style>
